import DM from 'DM';
import isInViewport from "../utils/in-view-port.js";

const CLASSNAMES = {
    CONTAINER: 'js-accordion',
    ITEM: 'js-accordion__item',
    BUTTON: 'js-accordion__button',
    IS_OPENED: 'is-opened'
};

const SELECTORS = {
    CONTAINER: `.${CLASSNAMES.CONTAINER}`,
    ITEM: `.${CLASSNAMES.ITEM}`
};

class Accordion {
    constructor(container) {
        this.container = container;
        this.items = [...this.container.querySelectorAll(SELECTORS.ITEM)];
        container.addEventListener('click', this.eventHandler.bind(this));
    }

    eventHandler(e) {
        const element = e.target;
        if (element.classList.contains(CLASSNAMES.BUTTON)) {
            const parent = element.closest(SELECTORS.ITEM)
            const isOpened = parent.classList.contains(CLASSNAMES.IS_OPENED)

            this.items.forEach(item => item.classList.remove(CLASSNAMES.IS_OPENED));
            if (!isOpened) {
                parent.classList.add(CLASSNAMES.IS_OPENED);
                if (!isInViewport(element)) {
                    const offset = element.offsetTop - 100;
                    this.scrollTo(offset);
                }
            }
        }
    }

    scrollToMethodAvailable() {
        return !!document.body.scrollTo;
    }

    scrollTo(offset) {
        if (this.scrollToMethodAvailable()) {
            window.scrollTo({
                top: offset
            });
        } else {
            document.body.scrollTop = offset;
        }
    }
}

[].forEach.call(document.querySelectorAll(SELECTORS.CONTAINER), item => new Accordion(item));
